import { useEffect, useRef } from "react";

const SoundWave = ({ className = "" }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const ctx = canvas.getContext("2d");
    let raf;
    let t = 0;

    const resize = () => {
      canvas.width = canvas.offsetWidth * window.devicePixelRatio;
      canvas.height = canvas.offsetHeight * window.devicePixelRatio;
    };
    resize();
    window.addEventListener("resize", resize);

    const draw = () => {
      const { width, height } = canvas;
      ctx.clearRect(0, 0, width, height);
      const lines = 3;
      for (let l = 0; l < lines; l++) {
        ctx.beginPath();
        const amp = (height / 6) * (1 - l * 0.25);
        const yBase = height * (0.35 + l * 0.15);
        for (let x = 0; x <= width; x += 6) {
          const y = yBase + Math.sin(x * 0.004 + t * (0.6 + l * 0.2) + l * 2) * amp
            * Math.sin(x * 0.0012 + t * 0.3);
          x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
        }
        ctx.strokeStyle = l === 0 ? "rgba(0,229,255,0.35)" : l === 1 ? "rgba(212,175,55,0.28)" : "rgba(0,229,255,0.14)";
        ctx.lineWidth = 1.4 * window.devicePixelRatio;
        ctx.stroke();
      }
      t += 0.012;
      if (!reduced) raf = requestAnimationFrame(draw);
    };
    draw();

    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", resize); };
  }, []);

  return <canvas ref={canvasRef} className={className} aria-hidden="true" />;
};

export default SoundWave;
